import React, {useCallback, useState} from "react";

const DEFAULT_YEAR_LABEL = "5";

export default function PeriodSwitcher(props) {
  const { labelList, handleSelectYear } = props;
  const [ checkedYearLabel, setCheckedYearLabel ] = useState(DEFAULT_YEAR_LABEL);

  const onClickYearLabel = useCallback(
    (target) => {
      setCheckedYearLabel(target.id);
      handleSelectYear(target.value);
    }, [setCheckedYearLabel]
  );

  return (
    <React.Fragment>
      <p className={"font-bold font-1-0rem"} style={{margin: "8px 0 4px 0"}}>支払い期間</p>
      <p className={"radio"} >
        {labelList.map((label) => {
          return <React.Fragment>
            <input type={'radio'} className={'radio'} id={label.year} value={label.lease_price} name={'year'} onChange={(e) => onClickYearLabel(e.target)} checked={label.year.toString() === checkedYearLabel}/>
            <label htmlFor={label.year}>{label.year}年</label>
          </React.Fragment>
        })}
      </p>
    </React.Fragment>
  )
}
